"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TwoWayBinding_1 = __importDefault(require("../Mixins/TwoWayBinding"));
exports.default = {
    props: {
        value: String,
    },
    mixins: [TwoWayBinding_1.default],
    methods: {
        onChange: function ($event) {
            this.update($event.target.value);
        }
    },
    beforeMount: function () {
        this.update(this.value);
    },
    beforeDestroy: function () {
        this.update(null);
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/ConventionServitude/Components/MultilineTextInput.vue
// module id = 244
// module chunks = 0